import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Button, CircularProgress, Tooltip } from '@mui/material';

export default function CreateButton({
  clickAction,
  sx = {},
  disabled = false,
  tooltipText = '',
  text = 'Download',
  loading = false,
  variant = 'contained',
  size = 'small',
  extraBtnProps = {},
}) {
  return (
    <Tooltip title={tooltipText} placement="top">
      <span>
        <Button
          disabled={disabled}
          variant={variant}
          size={size}
          sx={{ ...sx }}
          onClick={clickAction}
          startIcon={
            loading ? (
              <CircularProgress color="inherit" size={'1rem'} />
            ) : (
              <AddIcon />
            )
          }
          {...extraBtnProps}
        >
          {text}
        </Button>
      </span>
    </Tooltip>
  );
}
